import { useQuery } from "urql";

import {
  GetDeskCollectionInvoicesDocument,
  InvoiceFilter,
  InvoiceOrderBy,
} from "../../../../graphql/generated.ts";
import { getApiPaginationData } from "../../../../utils/api.ts";
import { ApiHookProps } from "../../types.ts";

export const useDeskCollectionInvoices = ({
  filter,
  orderBy,
  page,
  pause,
}: ApiHookProps<InvoiceFilter, InvoiceOrderBy>) => {
  const pagination = getApiPaginationData(page);
  const variables = {
    filter,
    orderBy,
    skip: pagination?.skip,
    take: pagination?.take,
  };
  return useQuery({
    query: GetDeskCollectionInvoicesDocument,
    variables,
    pause,
  });
};
